import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IDecal } from 'modelos/src';

export type DecalAnchor =
  | 'top-right'
  | 'top-left'
  | 'bottom-right'
  | 'bottom-left'
  | 'cover';

@Component({
  selector: 'app-decal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './decal.component.html',
  styleUrl: './decal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class DecalComponent {
  @Input() decal?: IDecal | null;
  @Input() anchor: DecalAnchor = 'top-right';
}
